export default __webpack_public_path__ + "static/iso_logo-daf20b9a173937e3604ac2cbcb1afd6c.png";